import * as React from 'react';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { isDefined } from '@grandvisionhq/utils';
import { toShippingTypes } from '../../../utils/map-product-to-shipping-types.js';

const OrderConfirmDeliveryIndicatorContainer = ({ lineItems  })=>{
    const productTypes = new Set(lineItems.map(({ productType  })=>productType && toShippingTypes(productType)
    ).filter((type)=>Boolean(type)
    ));
    // This will be used when the basic variant of the DeliveryIndicator is enabled
    const availability = lineItems.map((item)=>item.availability
    );
    // This will be used if the full date variant of the DeliveryIndicator is enabled (feature toggle)
    const deliveryItems = lineItems.map((item)=>{
        if ('sku' in item) {
            return {
                sku: item.sku,
                quantity: 1
            };
        }
    }).filter(isDefined);
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        items: deliveryItems,
        availability: availability,
        productTypes: productTypes,
        "data-t": "order-confirm-delivery-indicator"
    });
};

export { OrderConfirmDeliveryIndicatorContainer };
//# sourceMappingURL=OrderConfirmDeliveryIndicatorContainer.js.map
